// removed by extract-text-webpack-plugin
module.exports = {"placeholder":"ConnectionsListPlaceholder__placeholder___1Gefk"};